<script setup lang="ts">
import { IconPosition } from '@clovyr/bed/components/controls/types';
import type { Manifest } from '@clovyr/pollen/manifest';

import { useLaunchButton } from '@/composables/useLaunchButton';
import NotifyIcon from '@clovyr/bed/components/icons/NotifyIcon.vue';

const props = withDefaults(
  defineProps<{
    app: Manifest;
    label?: string;
    reversed?: boolean;
    isComingSoon?: boolean;
  }>(),
  {
    label: 'launch',
    reversed: false,
  },
);

const { handleLaunchClicked } = useLaunchButton(props.app);

const buttonLabel = computed(() =>
  props.isComingSoon ? 'Coming Soon' : (props.label ?? 'Launch'),
);
</script>

<template>
  <div class="launch-btn">
    <Button
      :label="buttonLabel"
      :iconPosition="IconPosition.Right"
      :reversed="reversed"
      :disabled="isComingSoon"
      @click="handleLaunchClicked"
    >
      <SproutIcon />
    </Button>
    <div v-if="isComingSoon" class="coming-soon-link">
      <a
        href="#"
        @click.prevent="
          $emit('notify-me', { appName: props.app.metadata.name, appId: props.app.metadata.id })
        "
      >
        <NotifyIcon /> Notify me when available
      </a>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';

.launch-btn {
  display: flex;
  flex-direction: column;
  align-items: center;

  :deep(.sprout-icon) {
    min-width: 20px;
    min-height: 20px;
  }
  :deep(.button__label) {
    margin-top: 0.2rem;
  }
}
.coming-soon-link {
  font-size: 14px;
  margin-top: 0.5rem;

  a {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: colors.color(grey, primary);
    margin-right: 0.5rem;
  }

  .notify-icon {
    margin-right: 0.25rem;
  }
}

.coming-soon-link:hover {
  .notify-icon {
    stroke: colors.color(action, primary);
  }
  a {
    color: colors.color(action, primary);
  }
}
</style>
